import { connect } from 'react-redux'
import ServiceHolidays from '../../components/services/edit/holidays/ServiceHolidays'
import { actionCreators } from '../../state/actions/services/index'
import { IStoreState } from '../../types/index'

const digitsInRandomNumber = 10000

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    serviceId: state.service.metadata.edit.serviceId,
    orgId: state.organizations.currentOrgId,
    holidaysList: state.serviceEdit.holidaysSection.list
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onAddClick: (orgId: number, serviceId?: number) => {
      return dispatch(actionCreators.holidaysAddItem(createEmptyHoliday(orgId, serviceId)))
    }
  }
}

const createEmptyHoliday = (orgId: number, serviceId?: number) => {
  return {
    id: `new-${Math.floor(Math.random() * digitsInRandomNumber)}`,
    from: '',
    until: '',
    date: new Date(),
    serviceId,
    orgId
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceHolidays)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceHolidays.ts